// Author Liang Gangqiang
// Date 2022-03-28 14:52:30

import * as model from "@/model/sithMes/quality/SithMesNcrProcessTaskModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";
import {customVuexVoPatternFactory} from "@/store/em/commonPattern/customVuexVoPatternFactory";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.SithMesNcrProcessTask(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_SITHMES_QUALITY_URL,
        selectRowsToItems: function (row) {
            return {value: row.id, text: row.workOrderCode}
        },
        callbackApi: process.env.VUE_APP_SITHMES_QUALITY_URL + '/sithMesNcrProcessTask/workflow/complete-feedback',
        processDefinitionKey: "sith_mes_quality_ncr",
        processBusinessData: Object
    })
    .withMutations({
        setProcessBusinessData(state, data) {
            state.processBusinessData = data
        }
    })
    .withPatternFactory(customVuexVoPatternFactory, {
        voState: 'sithMesNcrProcessTaskProcessVo'
    })
    .buildStore()
